import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './AuthContext';
import LoginPage from './LoginPage';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, loading, authDisabled } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        sx={{ backgroundColor: '#0a0a0a' }}
      >
        <CircularProgress sx={{ color: '#2563eb' }} />
      </Box>
    );
  }

  if (!authDisabled && !session) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
